import Flex from "../../../../../components/Flex";
import SideSheetDrawer from "../../../../../components/SidesheetDrawer";
import { DisclosureHost } from "../../../../../hooks/use-disclosure";
import Text from "../../../../../components/Text";
import ProfileViewer from "../../../../../components/ProfileViewer";
import { formatDate } from "../../../../../utils/date-time-utility";
import { GENDER_RECORD } from "../../../../../constants";
import {
  getAddressFormat,
  getFormattedId,
  getIdFromObj,
  getValueFromObj,
  replaceUnderScoreAddSpace,
} from "../../../../../utils/utils";
import OutlineCard from "../../../../../components/OutlineCard";
import { useGetPatientPaymentById } from "../../../../../queries/billings/payments/use-get-patient-payment-by-id";
import { useGetPatient } from "../../../../../queries/use-get-patient-uuid";
import { getPaymentModeLabel } from "./patient-payments-constant";
// import EnterSuperBills from "./EnterSuperBills"; // ECRH-5024: section removed

interface ViewPatientPaymentProps {
  disclosureHost: DisclosureHost;
  title?: string;
}

const ViewPatientPayment = ({
  disclosureHost,
  title,
}: ViewPatientPaymentProps) => {
  // const isReferralOut = useQueryParams("activeReferral") === "referral-out";
  // const isReferralIn = useQueryParams("activeReferral") === "referral-in";

  const { data } = useGetPatientPaymentById({
    patientPaymentId: disclosureHost?.data,
  });

  const patientPaymentData = data?.data;
  const patientUuid = getIdFromObj((patientPaymentData as any)?.patient);
  const { data: patient } = useGetPatient(patientUuid);
  return (
    <SideSheetDrawer
      open={disclosureHost.opened}
      onClose={disclosureHost.close}
      title={title || "Payment"}
      w="900px"
    >
      {patientPaymentData && (
        <Flex flexDirection={"column"} gap={1}>
          {/* patient section  */}
          <OutlineCard
            style={{
              height: "fit-content",
              padding: "15px",
              overflow: "auto",
              width: "100%",
            }}
          >
            <Flex
              style={{
                // height: "50%",
                padding: "2px",
                overflow: "auto",
                flexDirection: "column",
              }}
            >
              <Text variant="h4" fontWeight={"medium"}>
                Patient Details
              </Text>
              <Flex gap={1} mt={3} justifyContent={"space-between"}>
                <ProfileViewer
                  gap={"10px"}
                  firstColW={3}
                  secondColW={8}
                  data={{
                    Name:
                      getValueFromObj((patientPaymentData as any)?.patient) ??
                      "-",
                    DOB:
                      formatDate((patientPaymentData as any)?.patientDOB) ??
                      "-",
                    Gender:
                      GENDER_RECORD[
                        (patientPaymentData as any)?.patientGender
                      ] ?? "-",
                    Address: getAddressFormat(patient?.address) || "-",
                  }}
                />
              </Flex>
            </Flex>
          </OutlineCard>

          {/* Bill and visit details */}
          <OutlineCard
            style={{
              height: "fit-content",
              padding: "15px",
              overflow: "auto",
              width: "100%",
            }}
          >
            <Flex
              style={{
                height: "50%",
                padding: "2px",
                overflow: "auto",
                flexDirection: "column",
              }}
            >
              <Text variant="h4" fontWeight={"medium"}>
                Bill and Visit Details
              </Text>
              <Flex gap={1} mt={3} justifyContent={"space-between"}>
                <ProfileViewer
                  gap={"10px"}
                  firstColW={3}
                  secondColW={8}
                  data={{
                    // "Invoice ID": (patientPaymentData as any)?.billIds
                    //   ? Object.keys((patientPaymentData as any)?.billIds)
                    //       .map((id) => getFormattedId(id))
                    //       .filter(Boolean)
                    //       .join(", ")
                    //   : "-",
                    "Visit ID": (patientPaymentData as any)?.visitIds
                      ? Object.keys((patientPaymentData as any)?.visitIds)
                          .map((id) => getFormattedId(id))
                          .filter(Boolean)
                          .join(", ") || "-"
                      : "-",
                    Provider:
                      getValueFromObj(
                        (patientPaymentData as any)?.billingProvider
                      ) ?? "-",
                  }}
                />
              </Flex>
            </Flex>
          </OutlineCard>

          {/* Transaction Information */}
          <OutlineCard
            style={{
              height: "fit-content",
              padding: "15px",
              overflow: "auto",
              width: "100%",
            }}
          >
            <Flex
              style={{
                height: "50%",
                padding: "2px",
                overflow: "auto",
                flexDirection: "column",
              }}
            >
              <Text variant="h4" fontWeight={"medium"}>
                Transaction Information
              </Text>
              <Flex gap={1} mt={3} justifyContent={"space-between"}>
                <ProfileViewer
                  gap={"10px"}
                  firstColW={3}
                  secondColW={8}
                  data={{
                    "Payment Date":
                      formatDate((patientPaymentData as any)?.paymentDate) ??
                      "-",
                    "Transaction ID":
                      (patientPaymentData as any)?.transactionId ??
                      (patientPaymentData as any)?.chequeId ??
                      "-",
                    Category:
                      replaceUnderScoreAddSpace(
                        (
                          patientPaymentData as any
                        )?.paymentCategory?.toLowerCase()
                      ) || "-",
                    "Payment Mode": getPaymentModeLabel(
                      (patientPaymentData as any)?.paymentMode
                    ),
                  }}
                />
              </Flex>
            </Flex>
          </OutlineCard>

          {/* Amount details */}
          <OutlineCard
            style={{
              height: "fit-content",
              padding: "15px",
              overflow: "auto",
              width: "100%",
            }}
          >
            <Flex
              style={{
                height: "50%",
                padding: "2px",
                overflow: "auto",
                flexDirection: "column",
              }}
            >
              <Text variant="h4" fontWeight={"medium"}>
                Amount Details
              </Text>
              <Flex gap={1} mt={3} justifyContent={"space-between"}>
                <ProfileViewer
                  gap={"10px"}
                  firstColW={3}
                  secondColW={8}
                  data={{
                    "Paid Amount": (
                      patientPaymentData as any
                    )?.amount?.toString()
                      ? `$ ${(patientPaymentData as any)?.amount?.toString()}`
                      : "-",

                    "Applied Amount": (
                      patientPaymentData as any
                    )?.appliedAmount?.toString()
                      ? `$ ${(
                          patientPaymentData as any
                        )?.appliedAmount?.toString()}`
                      : "-",
                    // "Unapplied Amount":
                    //   (
                    //     patientPaymentData as any
                    //   )?.unappliedAmount?.toString() ?? "-",
                  }}
                />
              </Flex>
            </Flex>
          </OutlineCard>

          {/*   Note */}
          <OutlineCard
            style={{
              height: "fit-content",
              padding: "15px",
              overflow: "auto",
              width: "100%",
            }}
          >
            <Flex
              style={{
                height: "50%",
                padding: "2px",
                overflow: "auto",
                flexDirection: "column",
              }}
            >
              <Text variant="h4" fontWeight={"medium"}>
                Note
              </Text>
              <Flex gap={1} mt={3} justifyContent={"space-between"}>
                <Text mt={"14px"} size={"14px"}>
                  {(patientPaymentData as any)?.note ?? "-"}
                </Text>
              </Flex>
            </Flex>
          </OutlineCard>

          {/* ECRH-5024: Removed lower "previous invoice" (EnterSuperBills) and Claims sections — only the 5 specified sections should render. */}
          {/* <OutlineCard
            style={{
              height: "fit-content",
              overflow: "auto",
              width: "100%",
            }}
          >
            <EnterSuperBills
              viewOnly={true}
              billIds={
                (patientPaymentData as any)?.billIds
                  ? Object.keys((patientPaymentData as any)?.billIds).map(
                      (it) => {
                        return {
                          value: it,
                          label: "",
                        };
                      }
                    )
                  : []
              }
              onClose={() => {}}
            />
          </OutlineCard>

          <OutlineCard
            style={{
              height: "fit-content",
              padding: "15px",
              overflow: "auto",
              width: "100%",
            }}
          >
            <Flex
              style={{
                height: "50%",
                padding: "2px",
                overflow: "auto",
                flexDirection: "column",
              }}
            >
              <Text variant="h4" fontWeight={"medium"}>
                Claims
              </Text>
              <Flex gap={1} mt={3} justifyContent={"space-between"}>
                <ProfileViewer
                  gap={"10px"}
                  firstColW={3}
                  secondColW={8}
                  data={{
                    "Claim IDs": (patientPaymentData as any)?.claimIds
                      ? Object.keys((patientPaymentData as any)?.claimIds)
                          .map((id) => getFormattedId(id))
                          .filter(Boolean)
                          .join(", ")
                      : "",
                  }}
                />
              </Flex>
            </Flex>
          </OutlineCard> */}
        </Flex>
      )}
    </SideSheetDrawer>
  );
};

export default ViewPatientPayment;
